import { h } from 'preact';
export const GitPullRequest = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("circle", { cx: "18", cy: "18", r: "3" }),
        h("circle", { cx: "6", cy: "6", r: "3" }),
        h("path", { d: "M13 6h3a2 2 0 0 1 2 2v7" }),
        h("line", { x1: "6", y1: "9", x2: "6", y2: "21" })));
};
//# sourceMappingURL=git-pull-request.js.map